module.exports = __webpack_public_path__ + "img/C.4e93d27d.jpg";